import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Form_Template_With_Fields } from 'src/app/Interfaces/Forms/FormTemplate.interface';

export interface FormModalState {
  isOpen: boolean;
  template: Form_Template_With_Fields | null;
  preloadValues: { [fieldId: number]: string | null };
}

export interface FormModalResult {
  confirmed: boolean;
  values: { ID_Field: number, Value: string | null }[];
  files: { ID_Field: number, File: File }[];
}

@Injectable({
  providedIn: 'root'
})
export class FormModalService {

  private state = new BehaviorSubject<FormModalState>({
    isOpen: false,
    template: null,
    preloadValues: {}
  });

  private result = new Subject<FormModalResult>();

  public state$ = this.state.asObservable();
  public result$ = this.result.asObservable();

  open(template: Form_Template_With_Fields, preloadValues: { [fieldId: number]: string | null } = {}): void {
    console.log('[FormModalService] open() called, template:', template?.Name);
    this.state.next({
      isOpen: true,
      template,
      preloadValues
    });
  }

  close(): void {
    this.state.next({
      isOpen: false,
      template: null,
      preloadValues: {}
    });
  }

  confirm(values: { ID_Field: number, Value: string | null }[], files: { ID_Field: number, File: File }[]): void {
    this.result.next({ confirmed: true, values, files });
    this.close();
  }

  cancel(): void {
    this.result.next({ confirmed: false, values: [], files: [] });
    this.close();
  }
}
